import React, { useEffect, useState } from "react";
import { myAnalytics } from "@/lib/api";
import { Sparkle, TrendUp, ArrowsClockwise, Eye, Stack, Tag } from "@phosphor-icons/react";

function Stat({ icon: Icon, label, value, testId }) {
  return (
    <div
      className="bg-[#0F1F38] border border-white/5 rounded-md px-5 py-4 flex items-center gap-4"
      data-testid={testId}
    >
      <Icon weight="duotone" className="h-6 w-6 text-[#C9A961] shrink-0" />
      <div className="min-w-0">
        <div className="font-display font-black text-2xl text-white leading-none">
          {value}
        </div>
        <div className="text-[10px] tracking-[0.2em] uppercase text-[#9AA5B5] mt-1 truncate">
          {label}
        </div>
      </div>
    </div>
  );
}

export default function AnalyticsWidget() {
  const [data, setData] = useState(null);

  useEffect(() => {
    myAnalytics().then(setData).catch(() => {});
  }, []);

  if (!data || data.total_offers === 0) return null;

  return (
    <section className="mb-8" data-testid="analytics-widget">
      <div className="flex items-center gap-2 mb-3">
        <Sparkle weight="fill" className="h-4 w-4 text-[#C9A961]" />
        <p className="text-xs tracking-[0.25em] uppercase font-bold text-[#C9A961]">
          Your forge stats
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        <Stat
          icon={Stack}
          label="Offers forged"
          value={data.total_offers}
          testId="stat-total-offers"
        />
        <Stat
          icon={ArrowsClockwise}
          label="Refinements"
          value={data.refined_offers}
          testId="stat-refined-offers"
        />
        <Stat
          icon={TrendUp}
          label="Avg bonuses"
          value={data.average_bonuses_per_offer}
          testId="stat-avg-bonuses"
        />
        <Stat
          icon={Eye}
          label="Input-hidden shares"
          value={data.shared_with_input_hidden}
          testId="stat-input-hidden"
        />
        <Stat
          icon={Tag}
          label="Top industry"
          value={data.top_industry || "—"}
          testId="stat-top-industry"
        />
      </div>
    </section>
  );
}
